// import { GetUserApplicationsParams, UserApplicationListResponse } from '../interfaces/UserApplicationInterface';
import { BuildUrlParams, SecurityPathBuilder, SecurityPathsEnum } from 'services/Paths';
import api from 'services/Interceptor';
import { GetUserApplicationsParams, UserApplicationListResponse } from '../interfaces/UserApplicationInterface';

export const GetUserApplicationsByUserId = async (id: number, params: GetUserApplicationsParams = {}): Promise<UserApplicationListResponse> => {
    let url = `${SecurityPathBuilder(SecurityPathsEnum.UserApplications)}/${id}`;

    const urlParams = BuildUrlParams(params as Record<string, string | string[] | undefined>);
    if (urlParams) {
        url += `?${urlParams}`;
    }

    const data = await api.get(url);
    return data;
};